import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { MetaInfoDescription } from './MetaInfoDescription';
import { DateFormat } from '../../DateFormat';
import { Strong } from '../../../../components/atoms/Strong/Strong';

export function ValidUntilMetaInfo({ validUntil, validityExpired }: { validUntil: string; validityExpired?: boolean }) {
  const { t } = useSonTranslation('MetaInfo');

  return (
    <MetaInfoDescription term={t('validUntil')}>
      <p className="meta-info__dateblock">
        <DateFormat date={validUntil} />
        {validityExpired && (
          <em className="meta-info__expired-date">
            <Strong>{t('attention')}: </Strong>
            {t('oldInformation')}
          </em>
        )}
      </p>
    </MetaInfoDescription>
  );
}
